import isObject from './isObject';

const unpaginatify = (value: any): any[] => {
  if (!isObject(value)) {
    throw new TypeError('value must be an object for unpaginatify(value).');
  }

  if (!Array.isArray(value['edges'])) {
    throw new TypeError('value.edges must be an array for unpaginatify(value).');
  }

  return (value['edges'] as any[]).map(item => item['node']);
};

export default unpaginatify;
